import React from 'react'
import { Image } from '@gousto-internal/citrus-react'

import icon1 from './svgs/1-person.svg'
import icon2 from './svgs/2-person.svg'
import icon3 from './svgs/3-person.svg'
import icon4 from './svgs/4-person.svg'
import icon5 from './svgs/5-person.svg'

import type { LoggedOutBoxSummaryPortionSize } from '../types'

type PortionSizeIconProps = {
  src: string
  portionSize: LoggedOutBoxSummaryPortionSize
}

const PortionSizeIcon = ({ src, portionSize }: PortionSizeIconProps) => (
  <Image
    data-testid={`portion-size-icon-${portionSize}`}
    src={src}
    alt={`icon for ${portionSize}-person box`}
    aria-hidden="true"
    width="44px"
    height="26px"
  />
)

export const portionSizeIcons: Record<LoggedOutBoxSummaryPortionSize, React.ComponentType> = {
  1: () => <PortionSizeIcon src={icon1} portionSize={1} />,
  2: () => <PortionSizeIcon src={icon2} portionSize={2} />,
  3: () => <PortionSizeIcon src={icon3} portionSize={3} />,
  4: () => <PortionSizeIcon src={icon4} portionSize={4} />,
  5: () => <PortionSizeIcon src={icon5} portionSize={5} />,
}
